import cls from "classnames";
import usePortalState, { portal } from "store/PortalState";
import { Transition } from "@headlessui/react";

function Portal() {
  const portalState = usePortalState((state) => state);

  return (
    <Transition
      as="div"
      show={portalState.isOpened}
      className="absolute inset-0 z-10 flex flex-col justify-end overflow-hidden"
    >
      <Transition.Child
        as="div"
        enter="transiton-all ease-out duration-150"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-all ease-in duration-100"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        className={cls(
          "absolute inset-0 bg-black bg-opacity-70 z-0"
        )}
        onClick={() => portal.closeWithTransition()}
      ></Transition.Child>
      <Transition.Child
        as="div"
        className={cls(
          "w-full relative z-[1]"
        )}
        enter="transiton-all ease-out duration-200"
        enterFrom="translate-y-full"
        enterTo="translate-y-0"
        leave="transition-all ease-in duration-150"
        leaveFrom="translate-y-0"
        leaveTo="translate-y-full"
      >
        {typeof portalState.content === "function"
          ? portalState.content()
          : portalState.content}
      </Transition.Child>
    </Transition>
  );
}

export default Portal;
